
<template>
    <div>
        <input v-model="text" :class="cssClass + ' global-simple-keyboard-input'"
               :maxlength="maxlength" :placeholder="placeholder"
               :readonly="readonly"
               :disabled="readonly"
               @focus="showKeyboard"
               @click="inputClick"
               ref="inputref">
        <SimpleKeyboard :input="text"
                        :input-name="inputName"
                        keyboard-class="simple-keyboard-numeric"
                        layout-name="default"
                        :layout="{
                            'default': [
                                '7 8 9',
                                '4 5 6',
                                '1 2 3',
                                '{bksp} 0 {enter}'
                            ]
                        }"
                        :display="{
                            '{bksp}': 'Delete',
                            '{enter}': 'Accept',
                        }"
                        @accept="accept"
                        @showing="$emit('showing')"
                        @hiding="$emit('hiding')"
                        @on-change="onChange" ref="simplekeyboardref"/>
    </div>
</template>

<script lang="ts">

import SimpleKeyboard from "./SimpleKeyboard.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        SimpleKeyboard,
    },
    props: {
        modelValue: {type: String, default: "" },
        placeholder: { type: String, required: false, default: ""},
        maxlength: { type: Number, required: true, default: 99 },
        cssClass: { type: String, required: false, default: "" },
        readonly: { type: Boolean, required: false, default: false },
        autoFocus: { type: Boolean, required: false, default: false },
        inputName: { type: String, required: false, default: "" },
    },
    data() {
        return {
            text: (this.modelValue||"") as string,
        };
    },
    methods: {
        showKeyboard(): void {
            if (this.readonly) return;
            setTimeout((): void => {
                (this.$refs.simplekeyboardref as typeof SimpleKeyboard).showKeyboard();
            }, 300); // delay so DOM is ready ($nextTick isn't enough)
        },
        onChange(input: string): void {
            if (this.readonly) return;
            if (input.length > this.maxlength) return;
            this.text = input;
        },
        inputClick(): void {
            (this.$refs.inputref as HTMLInputElement).focus();
            this.showKeyboard();
        },
        accept(): void {
            this.$emit("accept");
        }
    },
    mounted(): void {
        if (this.autoFocus) {
            setTimeout((): void => {
                (this.$refs.inputref as HTMLInputElement).focus();
            }, 300); // delay so DOM is ready ($nextTick isn't enough)
        }
    },
    watch: {
        text(): void {
            this.$emit("update:modelValue", this.text);
        }
    }
});
</script>
